import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { addCity, fetchAllCountries, fetchAllStates, updateCity } from "../../../slices/city";
import { useEffect } from "react";

const validationSchema = Yup.object().shape({
    country_id: Yup.string()
        .required("Country is required"),
    state_name: Yup.string()
        .required("State is required"),
    name: Yup.string()
        .min(3, "City Name must be at least 3 characters")
        .max(50, "City Name must not exceed 50 characters")
        .matches(/^[a-zA-Z\s]+$/, "City Name can only contain letters")
        .required("City Name is required"),
    city_code: Yup.string()
        .min(3, "City Code must be at least 3 characters")
        .max(20, "City Code must not exceed 20 characters")
        .matches(/^[a-zA-Z\s]+$/, "City Code can only contain letters")
        .required("City Code is required"),
});
const AddCityForm = ({ editData = null,onSuccess }) => {
    const dispatch = useDispatch()
    const { allCountries, allStates, isLoading } = useSelector((state) => state.bmrCity);
    const initialValues = {
        country_id: editData?.country_id
            ? String(editData.country_id)
            : (editData?.country_details?.id ? String(editData.country_details.id) : ""),
         state_name: editData?.state_id ? String(editData.state_id) : "",
        name: editData?.name ?? "",
        city_code: editData?.city_code ?? "",
    };
    useEffect(() => {
        dispatch(fetchAllCountries());
    }, [dispatch]);


    const countryOptions = Array.isArray(allCountries)
        ? allCountries.map((c) => ({
            label: c.name,
            value: String(c.id),
        }))
        : [];
    const stateOptions = Array.isArray(allStates)
        ? allStates.map((s) => ({
            label: s.name,
            value: String(s.id),
        }))
        : [];

    const handleSubmit = async (values) => {
    const payload = {
        name: values.name,
        city_code: values.city_code,
        country_id: values.country_id,
        state_id: values.state_name};

    if (editData) {
        await dispatch(updateCity({ data: payload, editId: editData.id }));
    } else {
        await dispatch(addCity(payload));
    }
    if (onSuccess) onSuccess(); 
};
    const handleCityCodeChange = (e) => {
        formik.setFieldValue("city_code", e.target.value.toUpperCase());
    };
    const handleCountryChange = (e) => {
        const selectedCountry = e.target.value;
        formik.setFieldValue("country_id", selectedCountry);
        formik.setFieldValue("state_name", "");
    };
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true
    })
    useEffect(() => {
        if (formik.values.country_id) {
            dispatch(fetchAllStates(formik.values.country_id));
        }
    }, [dispatch, formik.values.country_id]);
    useEffect(() => {
        const resolveCountryFromState = async () => {
            if (!editData || formik.values.country_id || !formik.values.state_name) return;

            try {
                const response = await dispatch(fetchAllStates()).unwrap();
                const states = response?.data?.states ?? [];
                const matchedState = states.find(
                    (stateItem) => String(stateItem.id) === String(formik.values.state_name)
                );

                if (matchedState?.country_id) {
                    formik.setFieldValue("country_id", String(matchedState.country_id));
                }
            } catch (error) {
                // Ignore fallback lookup errors; user can still select country manually.
            }
        };

        resolveCountryFromState();
    }, [dispatch, editData, formik.values.country_id, formik.values.state_name]);


    const formOptions = [
        {
            label: 'Country',
            type: 'select',
            name: 'country_id',
            required: true,
            placeholder: "Select Country",
            options: countryOptions,
            onChange: handleCountryChange
        },
        {
            label: 'State',
            type: 'select',
            name: 'state_name',
            required: true,
            placeholder: "Select State",
            options: stateOptions,
            disabled: !formik.values.country_id
        },
        {
            label: 'City Name',
            type: 'text',
            name: 'name',
            required: true,
            placeholder: "Enter City",
        },
        {
            label: 'City Code',
            type: 'text',
            name: 'city_code',
            required: true,
            placeholder: 'Enter City Code ',
            onChange: handleCityCodeChange 
        },

    ];

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                            <FormikControl formik={formik} {...props} />
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton
                            loading={isLoading}
                            fullWidth type="submit" variant="contained">{editData ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AddCityForm;